import ProductsMapFrame from './productsmapFrame.jsx';
import BenefitProducts from './benefitsFrame.jsx'; // rename jsx file?
import MobileMenu from './Benefits/MobileMenu.jsx';

const frameComponentsMap = {
    productsmap: ProductsMapFrame,
    productsmapsingle: ProductsMapFrame,
    benefitproducts: BenefitProducts,
    benefitproductsmobilemenu: MobileMenu
}

export default frameComponentsMap;
